import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _taggedTemplateLiteral from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { metaSchemas, CONTRACTABLE_BUFFER, PACKAGE_TYPE } from "@/lib/constants";
import { gql } from "@apollo/client";
import { createPageInfo, largeThumbnailUrl, mediumThumbnailUrl, metaResolveType, smallThumbnailUrl, thumbnailUrl, values, genres, isDateRangeIn, isAllowedRating as _isAllowedRating, ratingMask } from "./helper";
export var typeDef = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  interface Meta {\n    id: ID!\n    name: String!\n    thumbnailUrl: String\n    smallThumbnailUrl: String\n    mediumThumbnailUrl: String\n    largeThumbnailUrl: String\n    header: String\n    description: String\n    schema_key: String\n    copyright: String\n    delivery_start_at: String\n    delivery_end_at: String\n    rights_control_type: String\n    parents: [Meta]\n    push_rank: String\n    rating: String\n    isAllowedRating: Boolean\n    rights: [Right]\n    genres: [Genre]\n    adultFlag: Boolean\n  }\n\n  type TVShowMeta implements Meta {\n    id: ID!\n    name: String!\n    thumbnailUrl: String\n    smallThumbnailUrl: String\n    mediumThumbnailUrl: String\n    largeThumbnailUrl: String\n    header: String\n    description: String\n    schema_key: String\n    copyright: String\n    delivery_start_at: String\n    delivery_end_at: String\n    rights_control_type: String\n    parents: [Meta]\n    push_rank: String\n    rating: String\n    isAllowedRating: Boolean\n    rights: [Right]\n    genres: [Genre]\n    adultFlag: Boolean\n    production_country: [String]\n    cast: String\n    staff: String\n    production_year: String\n    episode_num: Int\n    meta_keywords: [String]\n    meta_description: String\n    channel: Meta\n    bookmark: Bookmark\n    distributor: String\n    course: Course\n    rtsid: String\n  }\n\n  type SeasonMeta implements Meta {\n    id: ID!\n    name: String!\n    thumbnailUrl: String\n    smallThumbnailUrl: String\n    mediumThumbnailUrl: String\n    largeThumbnailUrl: String\n    header: String\n    description: String\n    schema_key: String\n    copyright: String\n    delivery_start_at: String\n    delivery_end_at: String\n    rights_control_type: String\n    parents: [Meta]\n    push_rank: String\n    rating: String\n    isAllowedRating: Boolean\n    rights: [Right]\n    genres: [Genre]\n    adultFlag: Boolean\n    production_country: [String]\n    cast: String\n    staff: String\n    production_year: String\n    episode_count: Int\n    meta_keywords: [String]\n    meta_description: String\n    channel: Meta\n  }\n\n  type EpisodeMeta implements Meta {\n    id: ID!\n    name: String!\n    thumbnailUrl: String\n    smallThumbnailUrl: String\n    mediumThumbnailUrl: String\n    largeThumbnailUrl: String\n    header: String\n    description: String\n    schema_key: String\n    copyright: String\n    delivery_start_at: String\n    delivery_end_at: String\n    rights_control_type: String\n    parents: [Meta]\n    push_rank: String\n    rating: String\n    isAllowedRating: Boolean\n    rights: [Right]\n    genres: [Genre]\n    adultFlag: Boolean\n    production_country: [String]\n    cast: String\n    staff: String\n    production_year: String\n    distributor: String\n    num: Int\n    duration: Float\n    meta_keywords: [String]\n    meta_description: String\n    channel: ChannelMeta\n    area_control_flag: Boolean\n    is_live: Boolean\n    tvShow: TVShowMeta\n    recommend: Int\n    resume_point: Int\n    last_viewing_at: String\n    source_epg_id: String\n    plalaFlag: String\n    rtsid: String\n  }\n\n  type LiveMeta implements Meta {\n    id: ID!\n    name: String!\n    thumbnailUrl: String\n    smallThumbnailUrl: String\n    mediumThumbnailUrl: String\n    largeThumbnailUrl: String\n    header: String\n    description: String\n    schema_key: String\n    copyright: String\n    delivery_start_at: String\n    delivery_end_at: String\n    rights_control_type: String\n    parents: [Meta]\n    push_rank: String\n    rating: String\n    isAllowedRating: Boolean\n    rights: [Right]\n    genres: [Genre]\n    adultFlag: Boolean\n    production_country: [String]\n    cast: String\n    staff: String\n    production_year: String\n    distributor: String\n    num: Int\n    duration: Float\n    meta_keywords: [String]\n    meta_description: String\n    channel: ChannelMeta\n    area_control_flag: Boolean\n    is_live: Boolean\n    tvShow: TVShowMeta\n    recommend: Int\n    start_over_flag: Boolean\n    catch_up_flag: Boolean\n    encode_start_date: String\n    encode_end_date: String\n    resume_point: Int\n    last_viewing_at: String\n    source_epg_id: String\n    plalaFlag: String\n    rtsid: String\n  }\n\n  type ChannelMetaHeroImage {\n    pc: String\n    mb: String\n  }\n\n  type ChannelMeta implements Meta {\n    id: ID!\n    name: String!\n    thumbnailUrl: String\n    smallThumbnailUrl: String\n    mediumThumbnailUrl: String\n    largeThumbnailUrl: String\n    header: String\n    description: String\n    schema_key: String\n    copyright: String\n    delivery_start_at: String\n    delivery_end_at: String\n    rights_control_type: String\n    parents: [Meta]\n    push_rank: String\n    rating: String\n    isAllowedRating: Boolean\n    rights: [Right]\n    genres: [Genre]\n    adultFlag: Boolean\n    meta_keywords: [String]\n    meta_description: String\n    live_flag: Boolean\n    video_flag: Boolean\n    heroImage: ChannelMetaHeroImage\n    contractStatus: Boolean @cacheControl(scope: PRIVATE, maxAge: 0)\n    contractAllowed: Boolean\n    tabMenu: [Link]\n    distributor: String\n  }\n  union MediaMeta = EpisodeMeta | LiveMeta\n\n  type MetaConnection {\n    data: [Meta]\n    pageInfo: PageInfo\n  }\n\n  type ChannelConnection {\n    data: [ChannelMeta]\n    pageInfo: PageInfo\n  }\n\n  enum EpisodeType {\n    LIVE_ONAIR\n    LIVE_BEFORE\n    CATCHUP\n    VIDEO\n  }\n\n  type Bookmark @cacheControl(maxAge: 0) {\n    meta_id: Int\n    bookmark_meta_id: Int\n    position: Int\n    bookmark_meta: Meta\n  }\n\n  type EntitledResult @cacheControl(scope: PRIVATE) {\n    data: [Meta]\n    pageInfo: PageInfo\n  }\n\n  type EntitledEpisodesResult @cacheControl(scope: PRIVATE) {\n    data: [MediaMeta]\n    pageInfo: PageInfo\n  }\n\n  type GenrePaletteEpisodesResult {\n    data: [MediaMeta]\n    pageInfo: PageInfo\n  }\n\n  type ChannelByCourseResult {\n    id: Int\n    name: String\n  }\n\n  type Query {\n    episode(id: Int): Meta\n\n    nextEpisode(id: Int): Meta\n\n    children(\n      id: Int\n      offset: Int\n      limit: Int\n      filter: JSONObject\n      sort: JSONObject\n    ): MetaConnection\n\n    channels(\n      offset: Int\n      limit: Int\n      filter: JSONObject\n      sort: String\n    ): ChannelConnection\n\n    channelsWithContractStatus(\n      offset: Int\n      limit: Int\n      filter: JSONObject\n      sort: String\n      uuid: String\n    ): ChannelConnection\n    channelDetail(id: Int): ChannelMeta\n    channelFeatureEpisodes(id: Int, offset: Int, limit: Int): MetaConnection\n\n    channelEpisodeSearch(\n      keyword: String\n      id: Int\n      episodeType: EpisodeType\n      offset: Int\n      limit: Int\n    ): MetaConnection\n\n    channelLiveSchedule(\n      id: Int\n      day: String\n      offset: Int\n      limit: Int\n    ): MetaConnection\n\n    channelLinearEpisodes(id: Int, filter: JSONObject ,offset: Int, limit: Int): MetaConnection\n\n    search(\n      keyword: String\n      filter: JSONObject\n      sort: String\n      offset: Int\n      limit: Int\n      minScore: Int\n    ): MetaConnection\n\n    searchTvShow(\n      keyword: String\n      filter: JSONObject\n      sort: String\n      offset: Int\n      limit: Int\n      minScore: Int\n    ): MetaConnection\n\n    title(id: Int): TVShowMeta\n\n    titles(\n      filter: JSONObject\n      sort: String\n      offset: Int\n      limit: Int\n    ): MetaConnection\n\n    entitled(\n      channelId: Int\n      contentType: String\n      offset: Int\n      limit: Int\n    ): EntitledResult\n\n    getEntitledStoreEpisodes(offset: Int, limit: Int): EntitledEpisodesResult\n\n    genrePaletteEpisodes(\n      channel: Int\n      genre: [Int]\n      offset: Int\n      limit: Int\n      sortOrder: String\n      type: String\n    ): GenrePaletteEpisodesResult\n  }\n"])));

function getUserRightIds(_x, _x2) {
  return _getUserRightIds.apply(this, arguments);
}

function _getUserRightIds() {
  _getUserRightIds = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(dataSources, info) {
    var userRightIds;
    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            info.cacheControl.setCacheHint({
              scope: "PRIVATE"
            });
            _context22.next = 3;
            return dataSources.user.rightIds();

          case 3:
            userRightIds = _context22.sent;
            return _context22.abrupt("return", userRightIds);

          case 5:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22);
  }));
  return _getUserRightIds.apply(this, arguments);
}

export var resolvers = {
  Query: {
    episode: function () {
      var _episode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_parent, _ref, _ref2) {
        var id, dataSources, res, meta;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                id = _ref.id;
                dataSources = _ref2.dataSources;
                _context.next = 4;
                return dataSources.episodes.getEpisode(id);

              case 4:
                res = _context.sent;
                meta = res.metas[0];
                return _context.abrupt("return", meta);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function episode(_x3, _x4, _x5) {
        return _episode.apply(this, arguments);
      }

      return episode;
    }(),
    nextEpisode: function () {
      var _nextEpisode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_parent, _ref3, _ref4) {
        var id, dataSources, meta;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                id = _ref3.id;
                dataSources = _ref4.dataSources;
                _context2.prev = 2;
                _context2.next = 5;
                return dataSources.episodes.nextEpisode(id);

              case 5:
                meta = _context2.sent;

                if (!(typeof meta === "string")) {
                  _context2.next = 10;
                  break;
                }

                return _context2.abrupt("return", null);

              case 10:
                return _context2.abrupt("return", meta);

              case 11:
                _context2.next = 16;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](2);
                return _context2.abrupt("return", null);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 13]]);
      }));

      function nextEpisode(_x6, _x7, _x8) {
        return _nextEpisode.apply(this, arguments);
      }

      return nextEpisode;
    }(),
    children: function () {
      var _children = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_parent, args, _ref5) {
        var dataSources, res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                dataSources = _ref5.dataSources;
                _context3.next = 3;
                return dataSources.meta.children(args);

              case 3:
                res = _context3.sent;
                return _context3.abrupt("return", {
                  data: res.metas,
                  pageInfo: createPageInfo(_objectSpread(_objectSpread({}, args), {}, {
                    count: res.total_count
                  }))
                });

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function children(_x9, _x10, _x11) {
        return _children.apply(this, arguments);
      }

      return children;
    }(),
    channels: function () {
      var _channels = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_parent, args, _ref6) {
        var dataSources, res, data;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                dataSources = _ref6.dataSources;
                _context4.next = 3;
                return dataSources.meta.channels(args);

              case 3:
                res = _context4.sent;
                data = res === null || res === void 0 ? void 0 : res.metas;
                return _context4.abrupt("return", {
                  data: data,
                  pageInfo: createPageInfo(_objectSpread(_objectSpread({}, args), {}, {
                    count: res.total_count
                  }))
                });

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function channels(_x12, _x13, _x14) {
        return _channels.apply(this, arguments);
      }

      return channels;
    }(),
    channelsWithContractStatus: function () {
      var _channelsWithContractStatus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_parent, args, _ref7) {
        var dataSources, res, data;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                dataSources = _ref7.dataSources;
                _context5.next = 3;
                return dataSources.meta.channels(args);

              case 3:
                res = _context5.sent;
                data = res === null || res === void 0 ? void 0 : res.metas;
                return _context5.abrupt("return", {
                  data: data,
                  pageInfo: createPageInfo(_objectSpread(_objectSpread({}, args), {}, {
                    count: res.total_count
                  }))
                });

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function channelsWithContractStatus(_x15, _x16, _x17) {
        return _channelsWithContractStatus.apply(this, arguments);
      }

      return channelsWithContractStatus;
    }(),
    channelFeatureEpisodes: function () {
      var _channelFeatureEpisodes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_parent, args, _ref8) {
        var dataSources, res;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                dataSources = _ref8.dataSources;
                _context6.next = 3;
                return dataSources.meta.channelFeatureEpisodes(args);

              case 3:
                res = _context6.sent;
                return _context6.abrupt("return", {
                  data: res.metas,
                  pageInfo: createPageInfo(_objectSpread(_objectSpread({}, args), {}, {
                    count: res.total_count
                  }))
                });

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function channelFeatureEpisodes(_x18, _x19, _x20) {
        return _channelFeatureEpisodes.apply(this, arguments);
      }

      return channelFeatureEpisodes;
    }(),
    channelDetail: function () {
      var _channelDetail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_parent, _ref9, _ref10) {
        var id, dataSources, channel;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                id = _ref9.id;
                dataSources = _ref10.dataSources;
                _context7.next = 4;
                return dataSources.meta.channelDetail(id);

              case 4:
                channel = _context7.sent;
                return _context7.abrupt("return", channel);

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function channelDetail(_x21, _x22, _x23) {
        return _channelDetail.apply(this, arguments);
      }

      return channelDetail;
    }(),
    channelEpisodeSearch: function () {
      var _channelEpisodeSearch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_parent, _ref11, _ref12) {
        var keyword, id, episodeType, offset, limit, dataSources, filter, res;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                keyword = _ref11.keyword, id = _ref11.id, episodeType = _ref11.episodeType, offset = _ref11.offset, limit = _ref11.limit;
                dataSources = _ref12.dataSources;
                filter = {
                  "values.channel": id
                };
                _context8.t0 = episodeType;
                _context8.next = _context8.t0 === "LIVE_ONAIR" ? 6 : _context8.t0 === "LIVE_BEFORE" ? 9 : _context8.t0 === "CATCHUP" ? 12 : _context8.t0 === "VIDEO" ? 16 : 18;
                break;

              case 6:
                filter["values.is_live"] = true;
                filter.time_range = {
                  "values.encode_start_date": {
                    lte: "now"
                  },
                  "values.encode_end_date": {
                    gt: "now"
                  }
                };
                return _context8.abrupt("break", 18);

              case 9:
                filter["values.is_live"] = true;
                filter.time_range = {
                  "values.encode_start_date": {
                    gt: "now"
                  }
                };
                return _context8.abrupt("break", 18);

              case 12:
                filter["values.is_live"] = true;
                filter["values.catch_up_flag"] = true;
                filter.time_range = {
                  "values.encode_end_date": {
                    lt: "now"
                  },
                  delivery_end_at: {
                    gt: "now"
                  }
                };
                return _context8.abrupt("break", 18);

              case 16:
                filter["values.is_live"] = false;
                return _context8.abrupt("break", 18);

              case 18:
                _context8.next = 20;
                return dataSources.meta.searchEpisode({
                  keyword: keyword,
                  filter: filter,
                  offset: offset,
                  limit: limit
                });

              case 20:
                res = _context8.sent;
                return _context8.abrupt("return", {
                  data: res.metas,
                  pageInfo: createPageInfo({
                    offset: offset,
                    limit: limit,
                    count: res.total_count
                  })
                });

              case 22:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function channelEpisodeSearch(_x24, _x25, _x26) {
        return _channelEpisodeSearch.apply(this, arguments);
      }

      return channelEpisodeSearch;
    }(),
    channelLiveSchedule: function () {
      var _channelLiveSchedule = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_parent, args, _ref13) {
        var dataSources, res;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                dataSources = _ref13.dataSources;
                _context9.next = 3;
                return dataSources.meta.channelLiveSchedule(args);

              case 3:
                res = _context9.sent;
                return _context9.abrupt("return", {
                  data: res.metas,
                  pageInfo: createPageInfo(_objectSpread(_objectSpread({}, args), {}, {
                    count: res.total_count
                  }))
                });

              case 5:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function channelLiveSchedule(_x27, _x28, _x29) {
        return _channelLiveSchedule.apply(this, arguments);
      }

      return channelLiveSchedule;
    }(),
    channelLinearEpisodes: function () {
      var _channelLinearEpisodes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_parent, args, _ref14) {
        var dataSources, res;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                dataSources = _ref14.dataSources;
                _context10.next = 3;
                return dataSources.meta.channelLinearEpisodes(args);

              case 3:
                res = _context10.sent;
                return _context10.abrupt("return", {
                  data: res.metas,
                  pageInfo: createPageInfo(_objectSpread(_objectSpread({}, args), {}, {
                    count: res.total_count
                  }))
                });

              case 5:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function channelLinearEpisodes(_x30, _x31, _x32) {
        return _channelLinearEpisodes.apply(this, arguments);
      }

      return channelLinearEpisodes;
    }(),
    search: function () {
      var _search = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(_parent, args, _ref15) {
        var dataSources, res;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                dataSources = _ref15.dataSources;
                _context11.next = 3;
                return dataSources.meta.searchEpisode(args);

              case 3:
                res = _context11.sent;
                return _context11.abrupt("return", {
                  data: res.metas,
                  pageInfo: createPageInfo(_objectSpread(_objectSpread({}, args), {}, {
                    count: res.total_count
                  }))
                });

              case 5:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      function search(_x33, _x34, _x35) {
        return _search.apply(this, arguments);
      }

      return search;
    }(),
    searchTvShow: function () {
      var _searchTvShow = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(_parent, args, _ref16) {
        var dataSources, res;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                dataSources = _ref16.dataSources;
                _context12.next = 3;
                return dataSources.meta.searchTvShow(args);

              case 3:
                res = _context12.sent;
                return _context12.abrupt("return", {
                  data: res.metas,
                  pageInfo: createPageInfo(_objectSpread(_objectSpread({}, args), {}, {
                    count: res.total_count
                  }))
                });

              case 5:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      function searchTvShow(_x36, _x37, _x38) {
        return _searchTvShow.apply(this, arguments);
      }

      return searchTvShow;
    }(),
    title: function () {
      var _title = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(_parent, _ref17, _ref18) {
        var id, dataSources, title;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                id = _ref17.id;
                dataSources = _ref18.dataSources;
                _context13.next = 4;
                return dataSources.meta.title(id);

              case 4:
                title = _context13.sent;
                return _context13.abrupt("return", title);

              case 6:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      function title(_x39, _x40, _x41) {
        return _title.apply(this, arguments);
      }

      return title;
    }(),
    titles: function () {
      var _titles = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(_parent, args, _ref19) {
        var dataSources, res;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                dataSources = _ref19.dataSources;
                _context14.next = 3;
                return dataSources.meta.titles(args);

              case 3:
                res = _context14.sent;
                return _context14.abrupt("return", {
                  data: res.metas,
                  pageInfo: createPageInfo(_objectSpread(_objectSpread({}, args), {}, {
                    count: res.total_count
                  }))
                });

              case 5:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }));

      function titles(_x42, _x43, _x44) {
        return _titles.apply(this, arguments);
      }

      return titles;
    }(),
    entitled: function () {
      var _entitled = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(_parent, args, _ref20) {
        var dataSources, res;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                dataSources = _ref20.dataSources;
                _context15.next = 3;
                return dataSources.meta.entitled(args);

              case 3:
                res = _context15.sent;
                return _context15.abrupt("return", {
                  data: res.metas,
                  pageInfo: createPageInfo(_objectSpread(_objectSpread({}, args), {}, {
                    count: res.total_count
                  }))
                });

              case 5:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }));

      function entitled(_x45, _x46, _x47) {
        return _entitled.apply(this, arguments);
      }

      return entitled;
    }(),
    getEntitledStoreEpisodes: function () {
      var _getEntitledStoreEpisodes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(_parent, args, _ref21) {
        var dataSources, res;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                dataSources = _ref21.dataSources;
                _context16.next = 3;
                return dataSources.meta.getEntitledStoreEpisodes(args);

              case 3:
                res = _context16.sent;
                return _context16.abrupt("return", {
                  data: res.metas,
                  pageInfo: createPageInfo(_objectSpread(_objectSpread({}, args), {}, {
                    count: res.total_count
                  }))
                });

              case 5:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16);
      }));

      function getEntitledStoreEpisodes(_x48, _x49, _x50) {
        return _getEntitledStoreEpisodes.apply(this, arguments);
      }

      return getEntitledStoreEpisodes;
    }(),
    genrePaletteEpisodes: function () {
      var _genrePaletteEpisodes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(_parent, args, _ref22) {
        var dataSources, res;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                dataSources = _ref22.dataSources;
                _context17.next = 3;
                return dataSources.meta.genrePaletteEpisodes(args);

              case 3:
                res = _context17.sent;
                return _context17.abrupt("return", {
                  data: res.metas,
                  pageInfo: createPageInfo(_objectSpread(_objectSpread({}, args), {}, {
                    count: res.total_count
                  }))
                });

              case 5:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17);
      }));

      function genrePaletteEpisodes(_x51, _x52, _x53) {
        return _genrePaletteEpisodes.apply(this, arguments);
      }

      return genrePaletteEpisodes;
    }()
  },
  Meta: {
    __resolveType: metaResolveType
  },
  TVShowMeta: {
    thumbnailUrl: thumbnailUrl,
    smallThumbnailUrl: smallThumbnailUrl,
    mediumThumbnailUrl: mediumThumbnailUrl,
    largeThumbnailUrl: largeThumbnailUrl,
    name: function name(obj, _args, _ref23) {
      var req = _ref23.req;
      return ratingMask(req, obj, "name");
    },
    description: function description(obj, _args, _ref24) {
      var req = _ref24.req;
      return ratingMask(req, obj, "description");
    },
    rights: function rights(obj) {
      return values(obj, "rights");
    },
    genres: genres,
    adultFlag: function adultFlag(obj) {
      return values(obj, "adult_flag");
    },
    rating: function rating(obj) {
      return values(obj, "rating");
    },
    isAllowedRating: function isAllowedRating(obj, _args, _ref25) {
      var req = _ref25.req;
      return _isAllowedRating(req, obj);
    },
    meta_keywords: function meta_keywords(obj) {
      return values(obj, "meta_keywords");
    },
    meta_description: function meta_description(obj) {
      return values(obj, "meta_description");
    },
    channel: function channel(obj) {
      return values(obj, "channel");
    },
    episode_num: function episode_num(obj) {
      return values(obj, "episode_num");
    },
    bookmark: function () {
      var _bookmark = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(parent, _args, _ref26) {
        var dataSources, bookmark, _bookmark$bookmark_me, _children$metas, children, meta;

        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                dataSources = _ref26.dataSources;
                _context18.next = 3;
                return dataSources.user.viewingBookmarkFromMeta(parent.id);

              case 3:
                bookmark = _context18.sent;

                if (!(bookmark && bookmark.position < bookmark.bookmark_meta.duration)) {
                  _context18.next = 8;
                  break;
                }

                return _context18.abrupt("return", bookmark);

              case 8:
                _context18.next = 10;
                return dataSources.meta.children({
                  id: parent.id,
                  filter: {
                    range: {
                      "values.num": {
                        gt: (bookmark === null || bookmark === void 0 ? void 0 : (_bookmark$bookmark_me = bookmark.bookmark_meta) === null || _bookmark$bookmark_me === void 0 ? void 0 : _bookmark$bookmark_me.num) || 0
                      }
                    }
                  },
                  offset: 0,
                  limit: 1
                });

              case 10:
                children = _context18.sent;
                meta = children === null || children === void 0 ? void 0 : (_children$metas = children.metas) === null || _children$metas === void 0 ? void 0 : _children$metas[0];

                if (!meta) {
                  _context18.next = 16;
                  break;
                }

                return _context18.abrupt("return", {
                  meta_id: parent.id,
                  bookmark_meta_id: meta.id,
                  position: 0,
                  bookmark_meta: meta
                });

              case 16:
                return _context18.abrupt("return", bookmark);

              case 17:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18);
      }));

      function bookmark(_x54, _x55, _x56) {
        return _bookmark.apply(this, arguments);
      }

      return bookmark;
    }(),
    course: function () {
      var _course = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(meta, _args, _ref27) {
        var _meta$values, _meta$values$rights, _right$values;

        var dataSources, right, courses;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                dataSources = _ref27.dataSources;
                right = meta === null || meta === void 0 ? void 0 : (_meta$values = meta.values) === null || _meta$values === void 0 ? void 0 : (_meta$values$rights = _meta$values.rights) === null || _meta$values$rights === void 0 ? void 0 : _meta$values$rights[0];

                if (!((right === null || right === void 0 ? void 0 : (_right$values = right.values) === null || _right$values === void 0 ? void 0 : _right$values.package_type) === PACKAGE_TYPE["svod"])) {
                  _context19.next = 9;
                  break;
                }

                _context19.next = 5;
                return dataSources.right.courses(right.id);

              case 5:
                courses = _context19.sent;
                return _context19.abrupt("return", courses.courses[0]);

              case 9:
                return _context19.abrupt("return", null);

              case 10:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19);
      }));

      function course(_x57, _x58, _x59) {
        return _course.apply(this, arguments);
      }

      return course;
    }()
  },
  SeasonMeta: {
    thumbnailUrl: thumbnailUrl,
    smallThumbnailUrl: smallThumbnailUrl,
    mediumThumbnailUrl: mediumThumbnailUrl,
    largeThumbnailUrl: largeThumbnailUrl,
    name: function name(obj, _args, _ref28) {
      var req = _ref28.req;
      return ratingMask(req, obj, "name");
    },
    description: function description(obj, _args, _ref29) {
      var req = _ref29.req;
      return ratingMask(req, obj, "description");
    },
    rights: function rights(obj) {
      return values(obj, "rights");
    },
    genres: genres,
    adultFlag: function adultFlag(obj) {
      return values(obj, "adult_flag");
    },
    rating: function rating(obj) {
      return values(obj, "rating");
    },
    isAllowedRating: function isAllowedRating(obj, _args, _ref30) {
      var req = _ref30.req;
      return _isAllowedRating(req, obj);
    },
    meta_keywords: function meta_keywords(obj) {
      return values(obj, "meta_keywords");
    },
    meta_description: function meta_description(obj) {
      return values(obj, "meta_description");
    },
    channel: function channel(obj) {
      return values(obj, "channel");
    }
  },
  EpisodeMeta: {
    thumbnailUrl: thumbnailUrl,
    smallThumbnailUrl: smallThumbnailUrl,
    mediumThumbnailUrl: mediumThumbnailUrl,
    largeThumbnailUrl: largeThumbnailUrl,
    name: function name(obj, _args, _ref31) {
      var req = _ref31.req;
      return ratingMask(req, obj, "name");
    },
    description: function description(obj, _args, _ref32) {
      var req = _ref32.req;
      return ratingMask(req, obj, "description");
    },
    rights: function rights(obj) {
      return values(obj, "rights");
    },
    genres: genres,
    adultFlag: function adultFlag(obj) {
      return values(obj, "adult_flag");
    },
    rating: function rating(obj) {
      return values(obj, "rating");
    },
    isAllowedRating: function isAllowedRating(obj, _args, _ref33) {
      var req = _ref33.req;
      return _isAllowedRating(req, obj);
    },
    meta_keywords: function meta_keywords(obj) {
      return values(obj, "meta_keywords");
    },
    meta_description: function meta_description(obj) {
      return values(obj, "meta_description");
    },
    channel: function channel(obj) {
      return values(obj, "channel");
    },
    area_control_flag: function area_control_flag(obj) {
      return values(obj, "area_control_flag");
    },
    is_live: function is_live(obj) {
      return values(obj, "is_live");
    },
    production_year: function production_year(obj) {
      return values(obj, "production_year");
    },
    distributor: function distributor(obj) {
      return values(obj, "distributor");
    },
    tvShow: function tvShow(obj) {
      return obj.parents.find(function (meta) {
        return meta.schema_id == metaSchemas.tvshow.id;
      });
    },
    recommend: function recommend(obj) {
      return values(obj, "recommend");
    },
    source_epg_id: function source_epg_id(obj) {
      return values(obj, "source_epg_id");
    },
    plalaFlag: function plalaFlag(obj) {
      return values(obj, "palala_flag");
    }
  },
  LiveMeta: {
    thumbnailUrl: thumbnailUrl,
    smallThumbnailUrl: smallThumbnailUrl,
    mediumThumbnailUrl: mediumThumbnailUrl,
    largeThumbnailUrl: largeThumbnailUrl,
    name: function name(obj, _args, _ref34) {
      var req = _ref34.req;
      return ratingMask(req, obj, "name");
    },
    description: function description(obj, _args, _ref35) {
      var req = _ref35.req;
      return ratingMask(req, obj, "description");
    },
    rights: function rights(obj) {
      return values(obj, "rights");
    },
    genres: genres,
    adultFlag: function adultFlag(obj) {
      return values(obj, "adult_flag");
    },
    rating: function rating(obj) {
      return values(obj, "rating");
    },
    isAllowedRating: function isAllowedRating(obj, _args, _ref36) {
      var req = _ref36.req;
      return _isAllowedRating(req, obj);
    },
    meta_keywords: function meta_keywords(obj) {
      return values(obj, "meta_keywords");
    },
    meta_description: function meta_description(obj) {
      return values(obj, "meta_description");
    },
    channel: function channel(obj) {
      return values(obj, "channel");
    },
    area_control_flag: function area_control_flag(obj) {
      return values(obj, "area_control_flag");
    },
    is_live: function is_live(obj) {
      return values(obj, "is_live");
    },
    production_year: function production_year(obj) {
      return values(obj, "production_year");
    },
    distributor: function distributor(obj) {
      return values(obj, "distributor");
    },
    start_over_flag: function start_over_flag(obj) {
      return values(obj, "start_over_flag");
    },
    catch_up_flag: function catch_up_flag(obj) {
      return values(obj, "catch_up_flag");
    },
    encode_start_date: function encode_start_date(obj) {
      return values(obj, "encode_start_date");
    },
    encode_end_date: function encode_end_date(obj) {
      return values(obj, "encode_end_date");
    },
    tvShow: function tvShow(obj) {
      return obj.parents.find(function (meta) {
        return meta.schema_id == metaSchemas.tvshow.id;
      });
    },
    recommend: function recommend(obj) {
      return values(obj, "recommend");
    },
    source_epg_id: function source_epg_id(obj) {
      return values(obj, "source_epg_id");
    },
    plalaFlag: function plalaFlag(obj) {
      return values(obj, "palala_flag");
    }
  },
  ChannelMeta: {
    thumbnailUrl: thumbnailUrl,
    smallThumbnailUrl: smallThumbnailUrl,
    mediumThumbnailUrl: mediumThumbnailUrl,
    largeThumbnailUrl: largeThumbnailUrl,
    name: function name(obj, _args, _ref37) {
      var req = _ref37.req;
      return ratingMask(req, obj, "name");
    },
    description: function description(obj, _args, _ref38) {
      var req = _ref38.req;
      return ratingMask(req, obj, "description");
    },
    rights: function rights(obj) {
      return values(obj, "rights");
    },
    genres: genres,
    adultFlag: function adultFlag(obj) {
      return values(obj, "adult_flag");
    },
    rating: function rating(obj) {
      return values(obj, "rating");
    },
    isAllowedRating: function isAllowedRating(obj, _args, _ref39) {
      var req = _ref39.req;
      return _isAllowedRating(req, obj);
    },
    meta_keywords: function meta_keywords(obj) {
      return values(obj, "meta_keywords");
    },
    meta_description: function meta_description(obj) {
      return values(obj, "meta_description");
    },
    live_flag: function live_flag(obj) {
      return values(obj, "live_flag");
    },
    video_flag: function video_flag(obj) {
      return values(obj, "video_flag");
    },
    heroImage: function heroImage(obj) {
      return obj.hero_image;
    },
    distributor: function distributor(obj) {
      return values(obj, "distributor");
    },
    contractStatus: function () {
      var _contractStatus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(parent, _args, _ref40, info) {
        var req, dataSources, userRightIds, rights, contract;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                req = _ref40.req, dataSources = _ref40.dataSources;

                if (!req.userToken) {
                  _context20.next = 8;
                  break;
                }

                _context20.next = 4;
                return getUserRightIds(dataSources, info);

              case 4:
                userRightIds = _context20.sent;
                rights = parent.values.rights;
                contract = rights.find(function (right) {
                  return userRightIds.includes(right.id);
                });
                return _context20.abrupt("return", !!contract);

              case 8:
                return _context20.abrupt("return", false);

              case 9:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20);
      }));

      function contractStatus(_x60, _x61, _x62, _x63) {
        return _contractStatus.apply(this, arguments);
      }

      return contractStatus;
    }(),
    contractAllowed: function contractAllowed(channel) {
      var _channel$values, _channel$values$right;

      var right = channel === null || channel === void 0 ? void 0 : (_channel$values = channel.values) === null || _channel$values === void 0 ? void 0 : (_channel$values$right = _channel$values.rights) === null || _channel$values$right === void 0 ? void 0 : _channel$values$right[0];

      if (right) {
        var _right$values2, _right$values3;

        return isDateRangeIn(right === null || right === void 0 ? void 0 : (_right$values2 = right.values) === null || _right$values2 === void 0 ? void 0 : _right$values2.delivery_start_date, right === null || right === void 0 ? void 0 : (_right$values3 = right.values) === null || _right$values3 === void 0 ? void 0 : _right$values3.delivery_end_date, {
          buffer: CONTRACTABLE_BUFFER,
          default: true
        });
      }

      return false;
    },
    tabMenu: function () {
      var _tabMenu = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(parent, _args, _ref41) {
        var _parent$values;

        var dataSources, _parent$values2, res;

        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                dataSources = _ref41.dataSources;

                if (!(parent !== null && parent !== void 0 && (_parent$values = parent.values) !== null && _parent$values !== void 0 && _parent$values.detail_tab_menu)) {
                  _context21.next = 6;
                  break;
                }

                _context21.next = 4;
                return dataSources.linkSet.linkSet(parent === null || parent === void 0 ? void 0 : (_parent$values2 = parent.values) === null || _parent$values2 === void 0 ? void 0 : _parent$values2.detail_tab_menu);

              case 4:
                res = _context21.sent;
                return _context21.abrupt("return", res === null || res === void 0 ? void 0 : res.links);

              case 6:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21);
      }));

      function tabMenu(_x64, _x65, _x66) {
        return _tabMenu.apply(this, arguments);
      }

      return tabMenu;
    }()
  },
  MediaMeta: {
    __resolveType: metaResolveType
  }
};